import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys.js";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

//----------------------------------------------------------------

const postCloseSecureCoConnection = async (requestData) => {
	try {
		// Authorization: [Call Centre ARP JWT token]
		//  /life/paymentClose/{requestId}
		const { jwtToken, requestId } = { ...requestData };

		const response = await request({
			url: `/paymentClose/${requestId}`,
			method: "POST",
			accessToken: jwtToken,
		});

		const returnResponse = response?.data;
		return returnResponse;
	} catch (ex) {
		console.error(ex);
	}
};

let captured = false; // Variable to track captured status

export const usePostCloseSecureCoConnection = (requestData) =>
	useQuery({
		queryKey: [queryKeys.CLOSE_SECURECO_CONNECTION],
		queryFn: async () => {
			const response = await postCloseSecureCoConnection(requestData);
			return response;
		},
		refetchOnWindowFocus: false,
		enabled:
			!!requestData?.jwtToken &&
			!!requestData.requestId &&
			requestData?.enabled,
	});
